import React from 'react';
import cN from 'classnames';
import styles from '../styles.module.scss';
import { I_ItineraryInfos } from '@Redux/search/interfaces';
import { formatTime, formatHour } from '@utils/formatDisplay';

interface I_FlightSegmentProps {
    data: I_ItineraryInfos;
}
const FlightSegment = ({ data }: I_FlightSegmentProps) => {
    const {
        DepDateTime,
        DepAirport,
        DepAirportName,
        TotalFlyDuration,
        Transfer,
        ArrDateTime,
        CrossDay,
        ArrAirport,
        ArrAirportName,
        TotalAirportDesc

    } = data;


    const checkTransferType = () => {
        if (TotalAirportDesc.length === 1) return { isHightLight: false, desc: `${TotalAirportDesc}` }

        const hasChangeAirport = TotalAirportDesc.find(item => item.includes("機場"));
        const hasChangeTerminal = TotalAirportDesc.find(item => item.includes("航厦"));
        const hasTransfer = TotalAirportDesc.find(item => item.includes("轉機"));

        if (hasChangeAirport) return { isHightLight: true, desc: `${hasTransfer}/${hasChangeAirport}` };
        if (hasChangeTerminal) return { isHightLight: true, desc: `${hasTransfer}/${hasChangeTerminal}` };
        return { isHightLight: false, desc: `${TotalAirportDesc}` };
    };

    const totalAirportDesc = checkTransferType().desc
    const isHightLight = checkTransferType().isHightLight




    return (
        <div className={styles.flightItem}>
            <div className={styles.dep}>
                <div className={styles.time}>
                    <div>{formatTime(DepDateTime)}</div>
                    <div className={styles.cityCode}>{DepAirport}</div>
                </div>
                <div className={styles.airport}>{DepAirportName}</div>
            </div>
            <div className={styles.mid}>
                <div className={styles.during}>{formatHour(TotalFlyDuration)}</div>
                {Transfer != 0 && <div className={cN(styles.transfer, { [styles.transfer_red]: isHightLight })}>{totalAirportDesc}</div>}
            </div>
            <div className={styles.arriv}>
                <div className={styles.time}>
                    <div>
                        {formatTime(ArrDateTime)}
                        {data.CrossDay < 0 && <span>{`${CrossDay}`}</span>}
                        {data.CrossDay > 0 && <span>{`+${CrossDay}`}</span>}
                    </div>
                    <div className={styles.cityCode}>{ArrAirport}</div>
                </div>
                <div className={styles.airport}>{ArrAirportName}</div>
            </div>
        </div>
    );
};

export default FlightSegment;
